<template>
  <div>
    <v-tabs
      fixed-tabs
      dark
      color="rgb(232, 155, 193)"
      class="nav--tabs"
      v-model="activeTab"
    >
      <div class="pa-3" v-for="tab in tabs" :key="tab.id">
        <v-tab @click="scrollToComponent(tab.id)">
          {{ tab.name }}
        </v-tab>
      </div>
    </v-tabs>
  </div>
</template>

<script>
export default {
  name: "NavBar",
  mounted() {
    window.addEventListener("scroll", this.onScroll);
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.onScroll);
  },
  data: () => ({
    tabs: [
      {
        // tabItem: AboutMe,
        id: "about",
        name: "About Me!",
      },
      // {
      //   id: "exp",
      //   name: "What's Up",
      // },
      // {
      //   id:"projects",
      //   name:
      // },
      {
        // tabItem: Contact
        id: "contact",
        name: "Contact",
      },
    ],
    activeTab: 0,
    // disableAnimation: new Set(["exp"]),
  }),
  methods: {
    isInViewport(el) {
      const rect = el.getBoundingClientRect();
      return (
        rect.top >= 0 &&
        rect.left >= 0 &&
        rect.bottom <=
          (window.innerHeight || document.documentElement.clientHeight) &&
        rect.right <=
          (window.innerWidth || document.documentElement.clientWidth)
      );
    },
    // getPercentageOnScreen(el) {
    //   // Get the relevant measurements and positions
    //   const viewportHeight = window.innerHeight;
    //   const scrollTop = window.scrollY;
    //   const elementOffsetTop = el.offsetTop;
    //   const elementHeight = el.offsetHeight;

    //   // Calculate percentage of the element that's been seen
    //   const distance = scrollTop + viewportHeight - elementOffsetTop;
    //   const percentage = Math.round(
    //     distance / ((viewportHeight + elementHeight) / 100)
    //   );

    //   // Restrict the range to between 0 and 100
    //   return Math.min(100, Math.max(0, percentage));
    // },
    onScroll() {
      this.tabs.forEach((tab, index) => {
        var el = document.getElementById(tab.id);
        if (this.isInViewport(el)) {
          this.activeTab = index;
        }
      });
    },
    scrollToComponent(refName) {
      var element = document.getElementById(refName);
      // var setAndUnsetAnimation = this.disableAnimation.has(refName);
      // if (setAndUnsetAnimation) {
      //   console.log("disable");
      //   console.log(element);
      // }
      // var headerOffset = 0;
      var y = element.getBoundingClientRect().top + window.pageYOffset;

      window.scrollTo({
        top: y,
        behavior: "smooth",
      });

      // if (setAndUnsetAnimation) {
      //   console.log("re-enable");
      // }
    },
  },
};
</script>

<style scoped>
.nav--tabs {
  position: -webkit-sticky;
  position: fixed;
  z-index: 200;
  top: 0;
}
</style>
